import { lazy, Suspense } from 'react';
import { usePath } from './lib/router.ts';
import { Home } from './pages/Home.tsx';
import { GoLive } from './pages/GoLive.tsx';
import { Watch } from './pages/Watch.tsx';
import { Obs } from './pages/Obs.tsx';
import { Channel } from './pages/Channel.tsx';
import { SignIn } from './pages/SignIn.tsx';
import { Account } from './pages/Account.tsx';
import { AccountDeleted, Contact, Faq, Privacy, Terms } from './pages/Info.tsx';
import { ChatPage, ObsChatOverlay } from './pages/ChatPage.tsx';
import { LiveNow } from './pages/LiveNow.tsx';

// Rarely opened pages load on demand, so viewers don't download them.
const Copyright = lazy(() => import('./pages/Copyright.tsx').then((m) => ({ default: m.Copyright })));
const Admin = lazy(() => import('./pages/Admin.tsx').then((m) => ({ default: m.Admin })));
import { Unsubscribe } from './pages/Unsubscribe.tsx';

export function App() {
  const path = usePath();
  if (path === '/') return <Home />;
  if (path === '/go-live') return <GoLive />;
  if (path === '/live') return <LiveNow />;
  if (path === '/obs') return <Obs />;
  if (path === '/claim') return <SignIn intent="claim" />;
  if (path === '/signin') return <SignIn intent="signin" />;
  if (path === '/account') return <Account />;
  if (path === '/faq') return <Faq />;
  if (path === '/contact') return <Contact />;
  if (path === '/privacy') return <Privacy />;
  if (path === '/terms') return <Terms />;
  if (path === '/copyright') return <Suspense><Copyright /></Suspense>;
  if (path === '/account-deleted') return <AccountDeleted />;
  if (path === '/admin') return <Suspense><Admin /></Suspense>;
  // Unsubscribe links in alert emails and texts: /u?t=<signed token>.
  if (path === '/u') return <Unsubscribe token={new URLSearchParams(location.search).get('t') ?? ''} />;
  const watch = /^\/s\/([a-z0-9]{4,16})\/?$/.exec(path);
  if (watch) return <Watch id={watch[1]!} />;
  const chat = /^\/s\/([a-z0-9]{4,16})\/chat\/?$/.exec(path);
  if (chat) return <ChatPage id={chat[1]!} />;
  const overlay = /^\/obs\/chat\/(ch_[a-z0-9]{20})\/?$/.exec(path);
  if (overlay) return <ObsChatOverlay channelId={overlay[1]!} />;
  const handle = /^\/([a-z0-9_-]{3,24})\/?$/i.exec(path);
  if (handle) return <Channel handle={handle[1]!.toLowerCase()} />;
  // The channel itself, even while they're live (zip2live.com/<handle> opens the live stream then).
  const about = /^\/([a-z0-9_-]{3,24})\/about\/?$/i.exec(path);
  if (about) return <Channel key="about" handle={about[1]!.toLowerCase()} about />;
  return <Channel handle="__missing__" />;
}
